module.exports = __webpack_public_path__ + "static/media/moreGraph.245c1f95.svg";